import { CAMPAIGN_TYPES } from '../constants/campaign';

export default {
  computed: {
    campaignType() {
      // Use $route so this updates when navigating between campaign types (Vue Router)
      if (this.$route && this.$route.path) {
        const match = this.$route.path.match(/\/campaigns\/([^/]+)/);
        return match ? match[1] : '';
      }
      const pageURL = window.location.href;
      return pageURL.substring(pageURL.lastIndexOf('/') + 1);
    },
    isOngoingType() {
      return this.campaignType === CAMPAIGN_TYPES.ONGOING;
    },
    isOnOffType() {
      return this.campaignType === CAMPAIGN_TYPES.ONE_OFF;
    },
    isWhatsappType() {
      return this.campaignType === CAMPAIGN_TYPES.WhatsApp;
    },
    isSmartAiEmailType() {
      return this.campaignType === CAMPAIGN_TYPES.SMART_AI_EMAIL;
    },
    isEmailCampaignType() {
      return this.campaignType === CAMPAIGN_TYPES.Email;
    },
  },
};
